import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
//#region src/utils/classNames.ts
const twMerge = extendTailwindMerge({ prefix: "tw" });
const cn = (...classes) => twMerge(clsx(...classes));
//#endregion
export { cn };

//# sourceMappingURL=classNames-BzrkDnOD.js.map